import BoxedIcon, { BoxedIconVariants } from '../../shared/boxed-icon';
import {
  CommandDashboardTileAccentColor,
  CommandDashboardTileDefinition,
} from './tile-config';

const ACCENT_TO_BOXED_ICON_VARIANT: Record<
  CommandDashboardTileAccentColor,
  BoxedIconVariants
> = {
  violet: 'violet',
  teal: 'teal',
  amber: 'amberTone',
  green: 'greenTone',
  blue: 'blue',
  blueDark: 'blueDark',
};

interface TileIconBadgeProps {
  tile: CommandDashboardTileDefinition;
  size?: number;
}

export default function TileIconBadge({ tile, size }: TileIconBadgeProps) {
  return (
    <BoxedIcon
      icon={tile.icon}
      variant={ACCENT_TO_BOXED_ICON_VARIANT[tile.accentColor]}
      size={size}
      padding="10px"
    />
  );
}
